import React, { useEffect, useState } from 'react';
import FilterSelect from './FilterSelect';
import SaveFilterSetting from './SaveFilterSetting';
import './index.scss';

interface FilterSaveProps {
  addFilterSaveListFetch: Function; // 添加方案方法
  editFilterSaveFetch: Function; // 编辑方案方法
  deleteFilterSaveFetch: Function; // 删除方案方法
  getFilterSaveListFetch: Function; // 删除方案方法
  filterSaveList: Array<any>; // 筛选器方法list
  fields: Array<Object>; // 页面渲染筛选器list
  filterSaveChange: Function; // 方案更改方法
  filterValue: any;
  currentPage: any;
  controls: any;
  selectedValue: any; // 选择方案值
  filterModalInfo: {
    // 编辑弹窗
    filterModalType: string | 'edit' | 'add';
    filterModalVisible: boolean;
  };
  setFilterModalInfo: any;
}

const FilterSave = (props: FilterSaveProps) => {
  const {
    filterSaveList,
    selectedValue,
    filterSaveChange,
    addFilterSaveListFetch,
    editFilterSaveFetch,
    deleteFilterSaveFetch,
    filterModalInfo,
    setFilterModalInfo,
    currentPage,
    fields,
    controls,
    filterValue,
  } = props;

  const [editFilter, setEditFilter] = useState({});
  const { filterModalType: type, filterModalVisible: visible } = filterModalInfo || {};

  return (
    <>
      <FilterSelect
        filterValue={filterValue}
        filterSaveList={filterSaveList}
        setFilterModalInfo={setFilterModalInfo}
        setEditFilter={setEditFilter}
        filterSaveChange={filterSaveChange}
        deleteFilterSaveFetch={deleteFilterSaveFetch}
        selectedValue={selectedValue}
      />
      {visible && (
        <SaveFilterSetting
          type={type}
          editFilter={editFilter}
          visible={visible}
          fields={fields}
          filterValue={filterValue}
          controls={controls}
          filterSaveList={filterSaveList}
          addFilterSaveListFetch={addFilterSaveListFetch}
          editFilterSaveFetch={editFilterSaveFetch}
          currentPage={currentPage}
          isNeedDiff={false}
          close={() => {
            setFilterModalInfo({
              filterModalType: '',
              filterModalVisible: false,
            });
            setEditFilter({});
          }}
        />
      )}
    </>
  );
};

export default FilterSave;
